import React from 'react';
import { PrismicRichText } from 'prismic/types/richtext';
import {
  EducationSlicesQuote,
  NewsSlicesQuote,
  PageSlicesQuote,
} from 'prismic-types';

import { Quote } from 'components/quote/Quote';
import { asText } from 'components/rich-text/RichText';

type Props = {
  citation?: PrismicRichText;
  content?: PrismicRichText;
};

export type QuoteSlice =
  | NewsSlicesQuote
  | EducationSlicesQuote
  | PageSlicesQuote;

export const QuoteSlice = ({ citation, content }: Props) => {
  return <Quote citation={asText(citation)} content={asText(content)} />;
};

export const prismicSliceToQuote = (s: QuoteSlice) => {
  const citation = (s.variation?.primary?.citation ?? null) as PrismicRichText;
  const content = (s.variation?.primary?.content ?? null) as PrismicRichText;

  if (!content) {
    return null;
  }

  return <QuoteSlice citation={citation} content={content} />;
};
